module.exports = __webpack_public_path__ + "img/NicoRoman.091069c1.jpg";